import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormFeedback } from 'reactstrap';
import moment from 'moment';
import classnames from 'classnames';
import { isMobile } from 'react-device-detect';
import _ from 'lodash';

import BrzwDatePicker from '../../../brzw_date_picker';

import './form_control_time_picker.scss';

const CLASS_NAME = 'form-control-time-picker';

class FormControlTimePicker extends Component {
  constructor(props) {
    super(props);

    this.state = { pickerVisible: false };

    this.calendarRef = React.createRef();
    this.nativeInputRef = React.createRef();

    this.handleChange = this.handleChange.bind(this);
    this.onChangeNative = this.onChangeNative.bind(this);
    this.openCalendar = this.openCalendar.bind(this);
    this.clearInput = this.clearInput.bind(this);
  }

  onChangeNative(event) {
    const { value } = event.target;
    if (value) {
      this.props.input.onChange(moment(value, 'HH:mm'));
    } else {
      this.props.input.onChange(null);
      this.nativeInputRef.current.blur();
    }
  }

  openCalendar() {
    if (isMobile) {
      this.nativeInputRef.current.click();
    } else if (!this.state.pickerVisible) {
      this.calendarRef.current.setOpen(true);
      this.setState({ pickerVisible: true });
    }
  }

  handleChange(value) {
    this.props.input.onChange(value);
    if (!isMobile) {
      this.calendarRef.current.setOpen(false);
      this.setState({ pickerVisible: false });
    }
  }

  clearInput(event) {
    _.invoke(event, 'preventDefault');
    _.invoke(event, 'stopPropagation');


    this.props.input.onChange(null);
    if (!isMobile) {
      this.calendarRef.current.setOpen(false);
      this.setState({ pickerVisible: false });
    }
  }

  render() {
    const {
      clearable,
      dateFormat,
      input: { value },
      injectTimes,
      meta: { error, touched },
      labelText,
      minTime,
      maxTime,
      timeIntervals,
      useCustomMobileInput,
    } = this.props;

    const placeholder = isMobile ? 'Select' : 'Select Time';

    return (
      <div className={CLASS_NAME}>
        <div
          className={classnames(`${CLASS_NAME}__wrapper`, {
            [`${CLASS_NAME}__wrapper--mobile`]: isMobile,
          })}
          onClick={this.openCalendar}
          role="button"
          tabIndex={0}
        >
          <label className={`${CLASS_NAME}__label`}>{labelText}</label>
          {clearable && value && (
            <div
              className={`${CLASS_NAME}__clear-btn`}
              onClick={this.clearInput}
              role="presentation"
            />
          )}
          {isMobile ? (
            <input
              ref={this.nativeInputRef}
              className={classnames(`${CLASS_NAME}__input`, { '-with-value': !!value })}
              type="time"
              onChange={this.onChangeNative}
              value={value && value.format('HH:mm')}
              placeholder={placeholder}
            />
          ) : (
            <BrzwDatePicker
              selected={value || null}
              inputClassName={`${CLASS_NAME}__input`}
              onChange={this.handleChange}
              placeholderText={placeholder}
              refFunc={this.calendarRef}
              useCustomMobileInput={useCustomMobileInput}
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={timeIntervals}
              dateFormat={dateFormat}
              timeCaption="Time"
              minTime={minTime}
              maxTime={maxTime}
              injectTimes={injectTimes}
              popperModifiers={{
                offset: {
                  enabled: true,
                  offset: '-15px, 10px',
                },
              }}
            />
          )}
        </div>
        {touched && <FormFeedback>{error}</FormFeedback>}
      </div>
    );
  }
}

FormControlTimePicker.propTypes = {
  clearable: PropTypes.bool,
  dateFormat: PropTypes.string,
  input: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
  }),
  injectTimes: PropTypes.array,
  labelText: PropTypes.string,
  minTime: PropTypes.any,
  maxTime: PropTypes.any,
  meta: PropTypes.shape({
    error: PropTypes.string,
  }),
  timeIntervals: PropTypes.number,
  useCustomMobileInput: PropTypes.bool,
};

FormControlTimePicker.defaultProps = {
  clearable: false,
  dateFormat: 'h:mma',
  injectTimes: [],
  maxTime: null,
  minTime: null,
  timeIntervals: 15,
  useCustomMobileInput: true,
};

export default FormControlTimePicker;
